import StoreController from '@projeccions-pdc/frontend-storage';
import FileDeliveryService from './apiclients/FileDeliveryService';
import AppController from './AppController';
import AppContext from './AppContext';
import axios from 'axios';
import AuthController from './Components/Auth/AuthController';
import queryString from 'query-string';

// let counter = 0;

let _fetchAPICache = {};
export async function fetchAPI(params, extraHeaders, cacheParams) {
    // counter++;
    // let curr = counter;
    // console.time('provesAmplify' + curr);
    try {
        let session = await AuthController.getSession();

        if (session) {
            let appContext = new AppContext();
            let newToken = session.getIdToken().getJwtToken();
            await appContext.setToken(newToken, false, session.isValid(), false);

            let config = appContext.getConfig();

            if (
                params.url.indexOf('http') !== -1 &&
                (params.url.indexOf(config.PdcDomain) !== -1 || params.url.indexOf(config.ApiDomain) !== -1)
            ) {
                let parsed = {};
                if (params.url.indexOf('?') !== -1) {
                    let aux = params.url.split('?');
                    let query = aux[1];
                    parsed = queryString.parse(query);
                }
                if (parsed.k !== undefined) {
                    parsed.k = newToken;
                    const stringified = queryString.stringify(parsed);
                    let aux = params.url.split('?');
                    params.url = `${aux[0]}?${stringified}`;
                } else if (params.token !== undefined && params.token !== '') {
                    params.token = newToken;
                }
            }
        }
    } catch (err) {
        console.log(err.message);
    }
    // console.timeEnd('provesAmplify' + curr);
    return internalFetchAPI(params, extraHeaders, cacheParams);
}

export function internalFetchAPI(params, extraHeaders, cacheParams) {
    if (cacheParams === undefined) {
        cacheParams = {
            active: false,
            ttl: 0,
        };
    }

    if (params.aOrigin !== undefined) {
        let mergeChar = '?';
        if (params.url.indexOf('?') !== -1) {
            mergeChar = '&';
        }
        params.url = `${params.url}${mergeChar}a_s=${params.aOrigin}`;
    }

    if (cacheParams.active === true && _fetchAPICache[params.url] !== undefined) {
        let cacheEntry = _fetchAPICache[params.url];
        if (new Date() - cacheEntry.date < cacheParams.ttl) {
            return Promise.resolve(cacheEntry.response);
        }
    }

    if (params.parseJSON === undefined) params.parseJSON = true;
    let defaultHeaders = {
        Authorization: params.token,
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json; charset=utf-8',
    };
    let headers = extraHeaders ? { ...defaultHeaders, ...extraHeaders } : defaultHeaders;
    return fetch(params.url, {
        method: params.method,
        mode: 'cors',
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: params.body ? JSON.stringify(params.body) : params.body,
        headers: new Headers(headers),
    }).then((response) => {
        if (response.ok) {
            if (params.parseJSON) {
                return response.json().then((json) => {
                    if (json !== undefined && json !== null && json.errorMessage !== undefined) {
                        console.warn('ha saltat el genèric ' + json.errorMessage);
                        return Promise.reject(new Error(json.errorMessage));
                    }
                    if (cacheParams.active === true) {
                        _fetchAPICache[params.url] = {
                            date: new Date(),
                            response: json,
                        };
                    }
                    return json;
                });
            } else {
                return response;
            }
        } else if (!params.parseJSON) {
            return Promise.reject(new Error(`Error ${response.status}`));
        } else {
            return response.json().then((data) => {
                // console.log('Error!');
                // console.log(data, response);
                let message = data.errorMessage !== undefined ? data.errorMessage : data.message;
                return Promise.reject(new Error(response.status + ' ' + message));
            });
        }
    });
}

export function getLocalizedName(language, names) {
    //console.log('getLocalizedName', names);
    if (!names) return;
    if (names[language]) return names[language];
    if (names.default) return names.default;
    return names[Object.keys(names)[0]];
}

export function getFileURL(fileId, urlModifier, source) {
    return FileDeliveryService.getFileURL(fileId, urlModifier, source);
}

export function isAdmin() {
    let appContext = new AppContext();
    let myInfo = appContext.getMyInfo();
    let isEmpty = Object.keys(myInfo).length === 0 && myInfo.constructor === Object;
    if (!isEmpty) {
        if (myInfo.isAdmin !== undefined) return myInfo.isAdmin;
    }
    return false;
}

export function isEditor() {
    let appContext = new AppContext();
    let myInfo = appContext.getMyInfo();
    let isEmpty = Object.keys(myInfo).length === 0 && myInfo.constructor === Object;
    if (!isEmpty) {
        if (myInfo.editor === undefined) return false;
        if (myInfo.editor.length !== 0) return true;
    }
    return false;
}

export function isAdminOrEditor() {
    let appContext = new AppContext();
    let myInfo = appContext.getMyInfo();
    let isEmpty = Object.keys(myInfo).length === 0 && myInfo.constructor === Object;
    if (!isEmpty) {
        if (myInfo.isAdmin === true) return true;
        if (myInfo.editor === undefined) return false;
        if (myInfo.editor.length !== 0) return true;
    }
    return false;
}

export function canEditCurrentContent(content) {
    let currGroupId = content ? content.groupId : undefined;

    if (isMtgOrColMine(currGroupId)) {
        return true;
    } else if (isAdmin()) {
        return true;
    } else if (isEditor()) {
        if (currGroupId === undefined) {
            return false;
        }
        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();
        if (myInfo.editor.indexOf(currGroupId) !== -1) {
            return true;
        }
    }
    return false;
}

export function userBelongsToPlatform() {
    let appContext = new AppContext();
    let platformId = appContext.getPlatformId();
    let myPlatforms = appContext.getMyPlatforms();

    // console.log('petició', platformId, myPlatforms);
    if (!platformId) return false;
    if (!myPlatforms) return false;
    if (!myPlatforms.platforms) return false;
    if (myPlatforms.platforms.indexOf(platformId) > -1) return true;
    return false;
}

export function isSmartphone(callback) {
    let mqls = [
        window.matchMedia('only screen and (max-width: 800px)'),
        //window.matchMedia('(max-height: 600px)'),
    ];

    let onMatchChange = (x) => {
        // console.log('hey', mqls[0].matches, mqls[1].matches, mqls[0].matches || mqls[1].matches);
        //|| mqls[1].matches
        if (callback) {
            callback(mqls[0].matches);
        }
    };

    for (let i = 0; i < mqls.length; i++) {
        onMatchChange(mqls[i]);
        mqls[i].addListener(onMatchChange);
    }

    let removeListener = () => {
        for (let i = 0; i < mqls.length; i++) {
            mqls[i].removeListener(onMatchChange);
        }
    };

    return removeListener;
}

export function isPrinting(callback) {
    let mqls = [
        window.matchMedia('only print'),
        //window.matchMedia('(max-height: 600px)'),
    ];

    let onMatchChange = (x) => {
        // console.log('hey', mqls[0].matches, mqls[1].matches, mqls[0].matches || mqls[1].matches);
        //|| mqls[1].matches
        if (callback) {
            callback(mqls[0].matches);
        }
    };

    for (let i = 0; i < mqls.length; i++) {
        onMatchChange(mqls[i]);
        mqls[i].addListener(onMatchChange);
    }

    let removeListener = () => {
        for (let i = 0; i < mqls.length; i++) {
            mqls[i].removeListener(onMatchChange);
        }
    };

    return removeListener;
}

export function parseToBoolean(currentProperty) {
    if (currentProperty !== undefined) {
        if (typeof currentProperty === 'string') {
            if (currentProperty === 'true') {
                return true;
            }
            return false;
        }
    }
    return currentProperty;
}

export async function isDeviceOnline() {
    // return false;
    let isOnline;
    if (process.env.REACT_APP_IS_CONTAINER === 'true') {
        let _StoreControllerNoPlatform = new StoreController('', '');
        if (_StoreControllerNoPlatform.get('isUserInit')) {
            let response = await AppController.getOnlineStatus();
            isOnline = response.isOnline;
        } else {
            isOnline = true;
        }
    } else {
        isOnline = window.navigator.onLine;
    }
    return isOnline;
}

export function downloadFile(baseURL) {
    return axios({
        url: baseURL,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filenameURL = response.request.responseURL;
        let fileName = filenameURL.substring(filenameURL.lastIndexOf('/') + 1, filenameURL.length);
        if (fileName.indexOf('?') !== -1) {
            fileName = fileName.split('?')[0];
        }
        link.setAttribute('download', fileName);
        // document.body.appendChild(link);
        link.click();
    });
}

export function createShareLink(contentId, resourceSubtype, localizedName, shareToken) {
    if (shareToken) {
        let contentType = resourceSubtype === 'm' ? 'metadocument' : 'category';
        let name = striptags(localizedName)
            .replace(/[\W_]+/g, ' ')
            .replace(/\s+/g, '-')
            .toLowerCase();
        contentId = contentId + '$' + name;

        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let config = appContext.getConfig();

        return `https://${platformId}.${config.PdcDomain}/share/${contentType}/show/${contentId}/?k=${shareToken}`;
    } else {
        return '';
    }
}

export function striptags(value) {
    if (!value) return '';
    return value.replace(/(<([^>]+)>)/gi, '');
}

export function isMtgOrColMine(groupId) {
    if (groupId === undefined) return false;
    let aux = groupId.substring(0, 2);
    if (aux === 'u-') {
        let tempsUserSub = groupId.replace('u-', '');
        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();
        if (tempsUserSub === myInfo.userSub) {
            return true;
        }
    }
    return false;
}

export function isElectron() {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
        return true;
    }
    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
        return true;
    }
    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }
    return false;
}

// export function getBase64Image(img) {
//     // Create an empty canvas element
//     var canvas = document.createElement('canvas');
//     canvas.width = img.naturalWidth;
//     canvas.height = img.naturalHeight;
//     // canvas.width = img.width;
//     // canvas.height = img.height;

//     // Copy the image contents to the canvas
//     var ctx = canvas.getContext('2d');
//     ctx.drawImage(img, 0, 0);

//     // Get the data-URL formatted image
//     // Firefox supports PNG and JPEG. You could check img.src to
//     // guess the original format, but be aware the using 'image/jpg'
//     // will re-encode the image.
//     var dataURL = canvas.toDataURL('image/png');
//     return dataURL;//dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
// }

export function redirectPath(location) {
    const values = queryString.parse(location.search);
    //console.log(values);
    //const locationState = location.state;
    const pathname = values && values.f;
    let response = pathname || '/';
    // console.log('redirectPath', response);
    return response;
}
